export { DataLayerEvent } from '@guiker/react-google-tag-manager'
export * from './PromotionContext'
